import { render } from "./ModerneTechnologie.vue?vue&type=template&id=7113d3a4&scoped=true"
import script from "./ModerneTechnologie.vue?vue&type=script&lang=js"
export * from "./ModerneTechnologie.vue?vue&type=script&lang=js"

import "./ModerneTechnologie.vue?vue&type=style&index=0&id=7113d3a4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7113d3a4"]])

export default __exports__